module.exports = __webpack_public_path__ + "img/news6.34d06e55.png";